<spark-summary-panel>
  <summary-panel-icon>

    <lds-icon
      name="user"
      size="md"
      appearance="inherit">
    </lds-icon>

  </summary-panel-icon>
  <summary-panel-content>

    <div class="row">
      <div class="col">
        <div class="summary-panel__title truncate">
          {{ individualSummary.name }}
        </div>
      </div>
      <div *ngIf="contactDeletionEnabled" class="col-auto">
        <div class="summary-panel__action-remove" (click)="delete()">
          <lds-icon name="remove" appearance="inherit">
          </lds-icon>
        </div>
      </div>
    </div>

  </summary-panel-content>

</spark-summary-panel>
